// extracted by mini-css-extract-plugin
export default {"text":"Text-text___-maSz","text_is_header":"Text-text_is_header___rfqAm","text_is_strong":"Text-text_is_strong___jGn6D"};